import { applyThemeTokens } from "./applyThemeTokens";

export const THEME_API_URL =
  (typeof process !== "undefined" && process.env.REACT_APP_THEME_API_URL) ||
  "https://portal.proppins.com/api/v1/public/theme";

/**
 * @returns {Promise<{ version?: number, updatedAt?: string } | null>}
 */
export async function fetchAndApplyTheme() {
  try {
    const res = await fetch(THEME_API_URL, {
      method: "GET",
      credentials: "omit",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) return null;
    const data = await res.json();
    if (data && data.tokens && typeof data.tokens === "object") {
      applyThemeTokens(data.tokens);
      return { version: data.version, updatedAt: data.updatedAt };
    }
  } catch {
    /* keep built-in CSS */
  }
  return null;
}
